class n extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.sliderTrack = this.querySelector("simple-slider-track"), this.slides = this.querySelectorAll("simple-slide"), this.contents = this.querySelectorAll("[data-content-index]"), this.pagination = this.querySelector("[data-pagination]"), this.mediaPlayers = this.querySelectorAll("media-player"), this.index = 1, this.pagination && (this.bullets = this.pagination.querySelectorAll("button")), this.slides.length < 2 || !this.sliderTrack)
      return;
    const t = this.getAttribute("data-next"), e = this.getAttribute("data-prev");
    !t || !e || (this.next = this.querySelector(t), this.prev = this.querySelector(e), !(!this.next || !this.prev) && (this.slideSize = this.slides[0].getBoundingClientRect().width, this.setUpObservers(), this.setUpListeners()));
  }
  trackProgress(t) {
    t.subscribe(({ currentTime: e }) => {
      const i = 1 - Number(e.toFixed(2)) / t.duration;
      this.bullets.length && this.bullets[this.index - 1].style.setProperty(
        "--progress",
        `${i}`
      ), this.contents.length && this.contents[this.index - 1].style.setProperty(
        "--progress",
        `${i}`
      );
    });
  }
  setUpObservers() {
    const t = {
      root: this.sliderTrack,
      threshold: 0.8
    }, e = new IntersectionObserver((i) => {
      i.forEach((s) => {
        if (s.isIntersecting) {
          const r = s.target.dataset.index;
          this.setIndex(Number(r));
        }
      });
    }, t);
    this.slides.forEach((i) => {
      e.observe(i);
    });
  }
  setUpListeners() {
    var t, e, i, s, r;
    (t = this.next) == null || t.addEventListener("click", () => {
      this.slide();
    }), (e = this.prev) == null || e.addEventListener("click", () => {
      this.slide(!0);
    }), (i = this.bullets) == null || i.forEach((a, d) => {
      a.addEventListener("click", () => {
        this.slideTo(d + 1);
      });
    }), (s = this.sliderTrack) == null || s.addEventListener("scroll", () => {
      this.dataset.inMotion = "true", setTimeout(() => {
        this.dataset.inMotion = "false";
      }, 500);
    }), (r = this.querySelector("[data-video-player-toggle]")) == null || r.addEventListener(
      "click",
      () => {
        this.setAttribute("data-interaction", "");
      }
    ), this.mediaPlayers.length && this.mediaPlayers.forEach((a) => {
      a.addEventListener("can-play", () => {
        this.trackProgress(a);
      });
    }), window.addEventListener("resize", () => {
      this.slideSize = this.slides[0].getBoundingClientRect().width;
    });
  }
  slide(t = !1) {
    var i;
    const e = t ? -1 : 1;
    (i = this.sliderTrack) == null || i.scrollBy({
      left: this.slideSize * e,
      behavior: "smooth"
    });
  }
  slideTo(t) {
    var i;
    const e = t - 1;
    (i = this.sliderTrack) == null || i.scrollTo({
      left: this.slideSize * e,
      behavior: "smooth"
    });
  }
  setIndex(t) {
    this.index = t, this.dataset.currentIndex = t.toString(), this.contents.forEach((e) => {
      e.classList.remove("visible", "opacity-100"), e.classList.add("invisible", "opacity-0");
    }), this.contents[t - 1].classList.remove("invisible", "opacity-0"), this.contents[t - 1].classList.add("visible", "opacity-100"), this.updateNavigation(), this.updatePagination(), this.updateMedia(), this.updateSlidestate();
  }
  updateNavigation() {
    var t, e, i, s, r, a;
    this.index == this.slides.length ? (this.dataset.progress = "end", (t = this.next) == null || t.setAttribute("aria-disabled", "true"), (e = this.prev) == null || e.removeAttribute("aria-disabled")) : this.index == 1 ? (this.dataset.progress = "start", (i = this.prev) == null || i.setAttribute("aria-disabled", "true"), (s = this.next) == null || s.removeAttribute("aria-disabled")) : (this.dataset.progress = "", (r = this.prev) == null || r.removeAttribute("aria-disabled"), (a = this.next) == null || a.removeAttribute("aria-disabled"));
  }
  updatePagination() {
    this.pagination && this.bullets.forEach((t, e) => {
      e + 1 == this.index ? t.setAttribute("data-active", "") : t.removeAttribute("data-active");
    });
  }
  updateMedia() {
    this.slides.forEach((t, e) => {
      var s;
      const i = (s = t.querySelector("video-player")) == null ? void 0 : s.mediaPlayer;
      if (i)
        if (e + 1 == this.index) {
          if (this.isReducedMotion || this.hasAttribute("data-interaction"))
            return;
          i.hasAttribute("data-can-play") && i.play();
        } else
          i.canplay && i.pause();
    });
  }
  updateSlidestate() {
    this.slides.forEach((t, e) => {
      e + 1 == this.index ? t.setAttribute("data-active", "") : t.removeAttribute("data-active");
    });
  }
  get isReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
}
window.customElements.define("video-previews-slider", n);
export {
  n as VideoPreviewsSlider
};
